module.exports = __webpack_public_path__ + "img/blog-logo.96b5a49.svg";